const messages = {
  makeChoice: "Make your choice",
  seeAll: "See all",
  clear: "Clear",
  back: "Back",
  save: "Save",
  close: "Close",
  of: "Of",
  to: "To",
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  copyrights: "© {date} Bridgestone Solutions. All rights reserved.",
  pageNotFound: "Page not found",
  accessDenied: "Access denied",
  search: "Search",
  year: "Year",
  buttons: {
    loading: "Loading...",
    export: "Export",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    next: "Next",
    back: "Back",
    skip: "Skip",
    send: "Send",
    clear: "Clear",
    close: "Close",
    readNow: "Read now",
    pointsList: "Points list",
    more: "More",
    reportError: "Report error",
    accept: "Accept",
    download: "Download",
    downloadAll: "Download all",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    downloadSelection: "Download selection",
    dealerInfoDownload: "DOWNLOAD",
    toTheBasket: "To basket",
    toOrderDelivery: "Continue to the delivery address",
    discover: "Discover",
    newAddress: "Create new delivery address",
    selectAddressBtn: "Select delivery address",
    toOrderSummary: "To the order overview",
    placeOrder: "Binding order",
    toDashboard: "To homepage",
    newOrder: "New order",
    userOrders: "To your orders",
    toSearch: "Search",
    select: "Select",
    moreCustomerNumbers: "+ ADD MORE CUSTOMER NUMBERS",
    loadMore: "Load more",
    toStaffDashboard: "To dashboard",
    toQuiz: "To quiz",
    vouchers: "Vouchers",
    exchangeVoucher: "Redeem voucher code",
    confirm: "Confirm",
    sharePoints: "Share points",
    create: "Create",
    update: "Update",
    toBDrive: "B-Drive",
    preview: "Preview",
    clickHere: "View details",
    setFilters: "Please set <b>at most one filter per column</b>",
    all: "All",
  },
  tooltips: {
    info: "Need help? 01 92 64 88 50 0",
  },
  confirmation: {
    header: "Confirmation required",
    message: "Do you want to delete this entry?",
  },
  nav: {
    consents: "Consents",
    dashboard: "Dashboard",
    accountDashboard: "Dashboard",
    account: "Profile",
    mailbox: "Inbox",
    singleMailbox: "Messages",
    stammdaten: "Master Data",
    news_feeds: "News feeds",
    pointsOverview: "Points overview",
    rewardsOverview: "Points overview",
    about: "About BS Plus",
    service_number: "Contact service",
    shop: "Rewards shop",
    salesPromotions: "Sales promotions",
    promotions: "My account",
    shopCategory: "Rewards shop",
    productDetails: "Product details",
    userOrders: "User orders",
    shoppingCart: "Shopping cart",
    orderDelivery: "Shipping address",
    orderSummary: "Order overview",
    orderComplete: "Order complete",
    text_page: "Static page",
    staff: "Service Dashboard",
    onlineTrainings: "Online trainings",
    trainings: "Trainings",
    training: "Training",
    trainingForm: "Training Form",
    staffVouchers: "Vouchers",
    wholesalerVouchers: "Vouchers",
    brochure_prices: "Price Lists & Brochures",
    investment: "Investment support",
    media: "Media",
    medias: "Media",
    wholesaler: "Wholesaler dashboard",
    contact_service: "Contact Information and Service",
    productInfo: "PRODUCT INFORMATION",
    bDrive: "Product Images",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Terms and Conditions of Participation",
    first_stop: "Bridgestone Tyre Guarantee",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Dashboard",
    accountDashboard: "Dashboard",
    account: "Profile",
    mailbox: "Inbox",
    singleMailbox: "Messages",
    stammdaten: "Master Data",
    news_feeds: "News feeds",
    pointsOverview: "Points overview",
    rewardsOverview: "Points overview",
    about: "About BS Plus",
    service_number: "Contact service",
    shop: "Rewards shop",
    salesPromotions: "Sales promotions",
    promotions: "My account",
    shopCategory: "Rewards shop",
    productDetails: "Product details",
    userOrders: "User orders",
    shoppingCart: "Shopping cart",
    orderDelivery: "Shipping address",
    orderSummary: "Order overview",
    orderComplete: "Order complete",
    staff: "Service Dashboard",
    onlineTrainings: "Online trainings",
    trainings: "Trainings",
    training: "Training",
    trainingForm: "Training Form",
    staffVouchers: "Vouchers",
    wholesalerVouchers: "Vouchers",
    brochure_prices: "Price Lists & Brochures",
    investment: "Investment support",
    media: "Media",
    medias: "Media",
    wholesaler: "Wholesaler dashboard",
    contact_service: "Contact Information and Service",
    productInfo: "PRODUCT INFORMATION",
    bDrive: "Product Images",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Terms and Conditions of Participation",
    first_stop: "Bridgestone Tyre Guarantee",
    payouts: "Payouts",
},
  menu: {
    account: "Profile",
    plus: 'About Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Sales Support",
    mailbox: "Inbox",
    about: "About BS Plus",
    trainingAndCourses: "Training and Courses",
    externalTraining: "External Training",
    productInfo: "Product Information",
    productBrochures: "Product Brochures",
    priceLists: "Price Lists",
    price: "Price",
    complaintForm: "Complaint Form",
    sales_support: "Sales Support",
    contact_service: "Contact Information and Service",
    logOut: "Log out",
    news: "News",
    news_feeds: "News feeds",
    service_number: "Contact service",
    salesPromotions: "Sales promotions",
    shop: "Shop",
    onlineTrainings: "Online trainings",
    trainings: "Trainings",
    brochure_prices: "Price Lists & Brochures",
    media: "Media",
    medias: "Media",
    stammdaten: "Master Data",
    preislisten: "Price Lists",
  },
  validation: {
    requiredField: "Field required",
  },
  sortBy: {
    default: "Sort by",
    desc: "Sort by: Newest",
    asc: "Sort by: Oldest",
    name: "Name",
    date: "Date",
    choiceBy: "Sort",
  },
  month: {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December"
  },
};


export default {
  messages,
};
